import { fetchResale, updateResaleOwner } from '@/api/business/resale'
import { UpdateResaleOwnerParams } from '@/api/business/resale/type'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const ResaleKeys = {
    all: ['resale'] as const,
    lists: () => [...ResaleKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ResaleKeys.lists(), page, perPage, filters] as const,
    details: () => [...ResaleKeys.all, 'detail'] as const,
    detail: (params: string) => [...ResaleKeys.details(), params] as const,
}

export const useResaleQuery = () => {
    return useQuery({
        queryFn: fetchResale,
        queryKey: ResaleKeys.lists(),
    })
}

export const useUpdateResaleOwnerMutation = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (data: UpdateResaleOwnerParams) => updateResaleOwner(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ResaleKeys.lists() })
        },
    })
}

